import en from './messages/en.json';
import ru from './messages/ru.json';

/** Canonical resources shared by frontend runtimes and the translation viewer. */
export const LOCALE_BUNDLES = { en, ru } as const;

/** Supported interface locales; adding one requires routing and validation updates. */
export const SUPPORTED_LOCALES = ['en', 'ru'] as const;

/** A supported interface locale. */
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

/** Fallback used when the visitor has not selected a supported locale. */
export const DEFAULT_LOCALE: SupportedLocale = 'en';

/** Shared language names for locale selectors. */
export const LOCALE_INFO = {
  en: { name: 'English', nativeName: 'English', flag: '🇬🇧' },
  ru: { name: 'Russian', nativeName: 'Русский', flag: '🇷🇺' },
} as const;

/** Narrow untrusted route values to the supported locale set. */
export function isValidLocale(locale: string): locale is SupportedLocale {
  return SUPPORTED_LOCALES.some((supported) => supported === locale);
}

export { ISO_COUNTRY_CODES, countryOptions } from './countries';
